import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import {
  saveToLocal,
  getFromLocal
} from '../util/storage'

Vue.use(Vuex)

let initData = {
  userToken: { // 授权信息
    persistence: false, // 是否持久化
    default: ''
  },
  userInfo: {
    persistence: false,
    default: {
    }
  },
  source: { // 2:"微信H5扫码用户,3:"支付宝H5扫码用户
    persistence: '2', // 是否持久化
    default: ''
  },
  brandIdStr: {
    persistence: true,
    default: ''
  },
  storeIdStr: {
    persistence: true,
    default: ''
  },
  jsCode: {
    persistence: true, // 是否持久化
    default: ''
  },
  isApp: {
    persistence: true, // 是否持久化
    default: 'wx'
  },
  openId: {
    persistence: true, // 是否持久化
    default: ''
  },
  openCardInfo: {
    default: {}
  },
  giftCoupon: {
    default: []
  },
  storeName: {
    default: ''
  },
  userInfoAll: {
    default: {}
  },
  backUrl: {
    default: 'recharge'
  },
  autoOrderStr: {
    default: ''
  },
  storeIdStrList: {
    default: []
  },
  refRule: {
    default: ''
  },
  storeInfo: {
    default: {}
  },
  orderCashier: {
    default: {}
  },
  rollback: {
    default: ''
  },
  openCardStoreInfo: {
    default: {}
  },
  storeDeployInfo: {},
  linkNO: {
    default: ''
  },
  amount: {
    default: ''
  }
}

let state = {}

let mutations = {}

for (let key in initData) {
  if (initData[key].persistence) {
    state[key] = getFromLocal('local', key) || getFromLocal('session', key, initData[key].default)
    mutations[key] = (storeState, obj) => {
      storeState[key] = obj
      saveToLocal('session', key, obj)
      saveToLocal('local', key, obj)
    }
  } else {
    state[key] = getFromLocal('session', key, initData[key].default)
    mutations[key] = (storeState, obj) => {
      storeState[key] = obj
      saveToLocal('session', key, obj)
    }
  }
}

export default new Vuex.Store({
  state,
  mutations,
  plugins: [
    persistedState({ storage: window.sessionStorage })
  ]
})
